import {
  ListNotificationSubscribers,
  ListNotificationSubscribersVariables
} from './__generated__/ListNotificationSubscribers'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'

import { gql } from 'apollo-boost'

const QUERY = gql`
  query ListNotificationSubscribers($input: ListNotificationSubscribersInputV2!) {
    listNotificationSubscribers: listNotificationSubscribersV2(input: $input) {
      nextCursor
      notificationSubscribers {
        id
        personId
        title
        unreadNotificationsCount
      }
    }
  }
`

export const useListNotificationSubscribers = (variables: ListNotificationSubscribersVariables, skip?: boolean) =>
  useQuery<ListNotificationSubscribers, ListNotificationSubscribersVariables>(QUERY, {
    variables,
    skip
  })

export const useListNotificationSubscribersLazy = (variables: ListNotificationSubscribersVariables) =>
  useLazyQuery<ListNotificationSubscribers, ListNotificationSubscribersVariables>(QUERY, {
    variables
  })
